import React from 'react';
import { ProgressBar } from 'react-bootstrap';

// #204009/#013223 — ô "Tỉ lệ đạt" dùng chung cho tab "Theo nhân viên" và tab "Theo phiên".
// Công thức phía server GIỮ NGUYÊN: pass_rate = Đạt / (Đạt + Không đạt)
// (qc-result-stats.service.ts:151 và :282) — mục Chờ (PENDING/IN_REVIEW) KHÔNG nằm ở mẫu số.
// Trước đây ô này chỉ in mỗi "100%", nên dòng mới chấm 15/44 mục vẫn hiện thanh xanh 100% như
// thể cả phiên đều tốt. Nay in thẳng số mục ĐÃ CHẤM trên TỔNG số mục ("15/44 đã chấm") và cảnh
// báo số mục còn chờ. #013223 — trước đây phần "đã chấm" in "Đạt/graded" (vd 14/20) nên phiên
// đã chấm hết cả 20 mục (14 đạt + 6 không đạt) vẫn trông như mới chấm 14 mục; nay tử số là số
// mục đã chấm (Đạt + Không đạt), mẫu số là tổng số mục của phiên.
export default function QcPassRateCell({ passRate, passed, failed, pending }) {
  if (passRate == null) {
    return <span className="text-muted">-</span>;
  }
  const graded = passed + failed;
  const total = graded + pending;
  return (
    <div className="d-flex align-items-center gap-2">
      <ProgressBar
        now={passRate * 100}
        striped={pending > 0}
        variant={passRate >= 0.8 ? 'success' : passRate >= 0.5 ? 'warning' : 'danger'}
        style={{ width: 60, height: 8 }}
      />
      <small>
        {Math.round(passRate * 100)}%
        <span className="text-muted"> ({graded}/{total} đã chấm)</span>
        {pending > 0 && <span className="text-warning fw-semibold"> · còn {pending} chưa chấm</span>}
      </small>
    </div>
  );
}
